import { createContext } from "react";

const allowanceContext = createContext();

export default allowanceContext;
